export const FormateDate = (date) => {
    if (!date) return "--";
    const d = new Date(date);
    if (!d || isNaN(d.getTime())) return "--";
    
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    
    return `${day}-${month}-${year}`; // Format as DD-MM-YYYY
  };